import type {
  BookingsOverviewState,
  BookingsOverviewStore,
} from '../domain/types'
import { createStore } from 'zustand'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'

const defaultInitialState: BookingsOverviewState = {
  cancelledBookings: {},
  pastBookings: {},
  upcomingBookings: {},
  vouchers: {},
  discount: null,
  bookingHistoryActiveTab: 'past',
  bookingOverviewPageLoadStatus: 'idle',
  addBookingLoadStatus: 'idle',
  addBookingReasonNotLinked: null,
  selectedUpcomingBookingId: null,
  isUpcomingBookingSheetOpen: false,
  isAddBookingSheetOpen: false,
  myPortalNotification: null,
}

export const bookingsOverviewStore = createBookingsOverviewStore()

export function createBookingsOverviewStore(initialState: BookingsOverviewState = defaultInitialState) {
  return createStore<BookingsOverviewStore>(set => ({
    ...initialState,
    initialize: (state) => {
      set(() => state)
    },

    setIn: (path, value) => {
      set(state => setIn(state, path, value) as BookingsOverviewState)
    },

    changeBookingHistoryTab: (tab) => {
      set(state => ({ ...state, bookingHistoryActiveTab: tab }))
    },
  }))
}
